import axios from '../client';

const getMainRoomConfiguration = async (roomName) => {
    return await axios.get(`/api/rooms/mainRoom/${roomName}/configurations`);
}

const updateMainRoomConfiguration = async (roomName, data) => {
    return await axios.put(`/api/rooms/mainRoom/${roomName}/configurations`, data);
}

export {
    getMainRoomConfiguration,
    updateMainRoomConfiguration
}